/**
 * `/approvals` URL contract. Split from `approvals-mobile-model.ts` because the
 * route's `validateSearch` is eager (entry bundle) and must not pull in the
 * screen's helpers.
 */
export interface ApprovalsSearch {
  /** Limit the list to one team (the AI hub's team picker, a team's settings). */
  team?: string | undefined;
  /** Open this request's detail (a push / Inbox deep link, or a tapped row). */
  approval?: string | undefined;
  /** `history` = decided requests; default = waiting. */
  view?: 'history' | undefined;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function validateApprovalsSearch(raw: Record<string, unknown>): ApprovalsSearch {
  const out: ApprovalsSearch = {};
  if (typeof raw.team === 'string' && raw.team) out.team = raw.team;
  if (typeof raw.approval === 'string' && UUID.test(raw.approval)) out.approval = raw.approval;
  if (raw.view === 'history') out.view = 'history';
  return out;
}
